export function findNearestAsofDate(dateList: string[], positionDate: string) {
  let nearestPastDate = null;
  let nearestFutureDate = null;
  
  // eslint-disable-next-line no-restricted-syntax
  for (const date of dateList) {
    if (date <= positionDate) nearestPastDate = date;
    else {
      nearestFutureDate = nearestFutureDate ?? date;
      break; // Since dates are sorted, we can stop searching once we find a future date.
    }
  }

  return nearestPastDate ?? nearestFutureDate;
}
